import React from "react";
import logger from "logger";
import { fade, withStyles, makeStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import FormControl from "@material-ui/core/FormControl";
import Warning from "TaskDialogCommon/Warning";
import Instruction from "TaskDialogCommon/Instruction";

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      //marginTop: "6px", //theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "7px 5px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

export default function CustomizedInputs(props) {
  const {
    label,
    warning,
    onChange,
    value,
    instruction = null,
    type = "text",
    placeholder = null,
  } = props;

  return (
    <>
      {label && (
        <div style={{ float: "left", marginTop: "10px", marginBottom: "10px" }}>
          <span>{label}</span>
        </div>
      )}
      {instruction && <Instruction>{instruction}</Instruction>}
      <div>
        <FormControl className="fullWidth">
          <BootstrapInput
            value={value}
            onChange={onChange}
            style={{
              textAlign: "center",
            }}
            className="fullWidth"
            type={type}
            placeholder={placeholder}
          />
        </FormControl>
      </div>
      {warning && <Warning>{warning}</Warning>}
    </>
  );
}
